import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {PixKeyCheckResponse} from '@gatewee/types/pix-key-check';
import {PixKeyType} from '@gatewee/types/recipient-bank-account';
import {Observable} from 'rxjs';

/** Response body from POST /pix/recipient/check-key. */
export type PixRecipientResponse = PixKeyCheckResponse;

@Injectable({
  providedIn: 'root',
})
export class PixRecipientService {
  constructor(private readonly http: HttpClient) {}

  checkKey(
    pixKey: string,
    pixKeyType: PixKeyType,
  ): Observable<PixRecipientResponse> {
    return this.http.post<PixRecipientResponse>('/pix/recipient/check-key', {
      pixKey,
      pixKeyType,
    });
  }
}
